import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography
} from '@mui/material';
import { useState } from 'react';
import { BackLinkAllTexts } from './BackLinkAllTexts';
import { BackLinkAllCss } from './BackLinkCss';
import { addSiteInDashboardText } from 'src/common/config/TextMessage';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';

export const SearchBackLinkComponent = ({
  getBackLinksDetailsFunc,
  loader,
  setSearchedUrl,
  openPlanModal
}) => {
  const competitorAnalysisUrl: any =
    useSelector(
      (state: RootState) => state.keywordResearch.competitorAnalysisUrl
    ) ?? '';
  const [url, setUrl] = useState(competitorAnalysisUrl || '');
  const [error, setError] = useState('');
  const textFieldSx = {
    '& .MuiOutlinedInput-root': {
      padding: '10px 14px',
      borderRadius: '6px',
      border: '1px solid var(--color-border)',
      maxHeight: '44px',
      '& fieldset': {
        border: 'none' // remove default outline border
      },
      '&:hover fieldset': {
        border: 'none'
      },
      '&.Mui-focused fieldset': {
        border: 'none'
      }
    },
    '& input': {
      padding: 0 // remove internal input padding
    }
  };

  const handleSearch = () => {
    if (!url.trim()) {
      setError(BackLinkAllTexts?.noUrlError);
      return;
    }

    if (!url.match(addSiteInDashboardText.urlRegex)) {
      setError(BackLinkAllTexts?.validUrlError);
      return;
    }

    setError(''); // clear error if everything is good
    setSearchedUrl(url);
    getBackLinksDetailsFunc(false, url);
  };
  return (
    <>
      <Box
        sx={{
          alignItems: Boolean(error) ? 'center' : 'end',
          ...BackLinkAllCss?.textFieldBoxSx
        }}
      >
        <Box sx={BackLinkAllCss?.textfieldSubBox}>
          <Typography sx={BackLinkAllCss?.enterWebSiteSx}>
            {BackLinkAllTexts?.enterWebSite}
          </Typography>
          <TextField
            variant="outlined"
            placeholder="E.g. https://yoursite.com/"
            fullWidth
            sx={textFieldSx}
            value={url}
            onChange={(e) => {
              setUrl(e.target.value);
              if (error) setError(''); // clear error while typing
            }}
            error={Boolean(error)}
            helperText={error}
            disabled={openPlanModal}
          />
        </Box>
        <Button
          variant="contained"
          sx={BackLinkAllCss?.searchBtnSx}
          onClick={handleSearch}
          disabled={openPlanModal}
        >
          {loader ? (
            <CircularProgress size={24} sx={{ color: 'var(--color-white)' }} />
          ) : (
            BackLinkAllTexts?.search
          )}
        </Button>
      </Box>
    </>
  );
};
